import React from 'react'
import Header from '../../subcategory/Header'
import SubCard from '../../../../../comon/SubCard'
import natarajasanaImg from '../../../../../assets/images/yoga/Natarajasana.png'
import VyaghrasanaImg from '../../../../../assets/images/yoga/Vyaghrasana.png'
import { useTranslation } from 'react-i18next'

const Digestion = () => {
    const {t} = useTranslation();
    return (
        <>
        <Header headtitle={t("yoga.diegestionyoga")} />
        <SubCard fitImg={natarajasanaImg} title={t("Natarajasana.title")} context={false} workoutLink='/natarajasana' />
        <SubCard fitImg={VyaghrasanaImg} title={t("Vyaghrasana.title")} context={false} workoutLink='/vyaghrasana' />
        </>
      )
    }

export default Digestion
